/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHosportsCustomSacCalculatorData } from './hosports-custom-sac-calculator.data';
import { IHosportsCustomSacCalculatorProps } from './hosports-custom-sac-calculator.props.autogenerated';

export interface IHosportsCustomSacCalculatorViewProps extends IHosportsCustomSacCalculatorProps<IHosportsCustomSacCalculatorData> {}

/**
 *
 * HosportsCustomSacCalculator component
 * @extends {React.PureComponent<IHosportsCustomSacCalculatorProps<IHosportsCustomSacCalculatorData>>}
 */
class HosportsCustomSacCalculator extends React.PureComponent<IHosportsCustomSacCalculatorProps<IHosportsCustomSacCalculatorData>> {
    public render(): JSX.Element | null {
      return this.props.renderView(this.props);
    }
}

export default HosportsCustomSacCalculator;
